import React from 'react';
import { Check, Block } from '../../shared/icons';

export default function() {
  return (
    <div className="legend">
      <div className="symbols">
        <div className="pair">
          <span className="symbol">
            <Check />
          </span>{' '}
          Roundtrip
        </div>
        <div className="pair">
          <span className="symbol">W</span> To Work Only
        </div>
        <div className="pair">
          <span className="symbol">H</span> To Home Only
        </div>
        <div className="pair">
          <span className="symbol">
            <Block />
          </span>{' '}
          Did Not Commute
        </div>
      </div>
      <div className="colors">
        <div className="pair">
          <span className="color black" /> Default
        </div>
        <div className="pair">
          <span className="color green" /> Saved
        </div>
        <div className="pair">
          <span className="color grey" /> Future / Past
        </div>
      </div>
    </div>
  );
}
